<!--<div class="container-fluid">-->

<form id="self-information" [formGroup]="regForm" (ngSubmit)="step11Submitted(regForm)" novalidate>

     
  <div class="form-row">
    <label style="font-weight: bold; font-size: x-large;">{{'Step9-Additional-Questions.TranslationSection.text1' | translate}}</label>
  
  </div><br><br>
  

<div>




  <div class="form-row">
    <div class="form-group col-lg-5 col-sm-5 col-md-5" >
      <label>1) {{'Step9-Additional-Questions.TranslationSection.text2' | translate}}
      </label>

    </div>
    <div class="form-group  col-lg-4 col-sm-4 col-md-4" >

      <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio"  id="Legal" formControlName="DENIED" value="Yes" >
          <label class="form-check-label" for="yes">{{'Step9-Additional-Questions.TranslationSection.text3' | translate}}</label>
      </div>
      <div class="form-check form-check-inline">
          <input  class="form-check-input" type="radio"  id="Legal" formControlName="DENIED" value="No" >
          <label class="form-check-label" for="yes">{{'Step9-Additional-Questions.TranslationSection.text4' | translate}}</label>
      </div>  
      
      <div style="color: red;" *ngIf="isSubmitted && this.regForm.get('DENIED').invalid">
        ***required field***
      </div>
    </div>
</div>

<div class="form-row">  
  <div class="form-group  col-lg-5 col-sm-5 col-md-5" >
    <label>2) {{'Step9-Additional-Questions.TranslationSection.text5' | translate}}
    </label>

  </div>
  <div class="form-group  col-lg-4 col-sm-4 col-md-4" >

    <div class="form-check form-check-inline">
        <input  class="form-check-input"  type="radio"  id="DISCHARGED" formControlName="DISCHARGED" value="Yes" >
        <label class="form-check-label" for="yes">{{'Step9-Additional-Questions.TranslationSection.text6' | translate}}</label>
    </div>
    <div class="form-check form-check-inline">
        <input class="form-check-input"  type="radio"  id="DISCHARGED" formControlName="DISCHARGED" value="No" >
        <label class="form-check-label" for="yes">{{'Step9-Additional-Questions.TranslationSection.text7' | translate}}</label>
    </div>   
    
    <div style="color: red;" *ngIf="isSubmitted && this.regForm.get('DISCHARGED').invalid">
      ***required field***
    </div>
  </div>
</div>

<div class="form-row">
<div class="form-group  col-lg-5 col-sm-5 col-md-5" >
  <label>3) {{'Step9-Additional-Questions.TranslationSection.text8' | translate}}
  </label>

</div>
<div class="form-group  col-lg-4 col-sm-4 col-md-4" >

  <div class="form-check form-check-inline">
      <input  class="form-check-input"  type="radio"  id="Crime" formControlName="REVOKED" value="Yes" >
      <label class="form-check-label" for="yes">{{'Step9-Additional-Questions.TranslationSection.text9' | translate}}</label>
  </div>
  <div class="form-check form-check-inline">
      <input class="form-check-input" type="radio"  id="Crime" formControlName="REVOKED" value="No" >
      <label class="form-check-label" for="yes">{{'Step9-Additional-Questions.TranslationSection.text10' | translate}}</label>
  </div>   
  
  <div style="color: red;" *ngIf="isSubmitted && this.regForm.get('REVOKED').invalid">
    ***required field***
  </div>
</div>
</div>

<div class="form-row">
<div class="form-group  col-lg-5 col-sm-5 col-md-5" >
<label>4) {{'Step9-Additional-Questions.TranslationSection.text11' | translate}}
</label>

</div>
<div class="form-group  col-lg-4 col-sm-4 col-md-4" >

<div class="form-check form-check-inline">
    <input  class="form-check-input"  type="radio"  id="RELATIVE" formControlName="RELATIVE" value="Yes" >
    <label class="form-check-label" for="yes">{{'Step9-Additional-Questions.TranslationSection.text12' | translate}}</label>
</div>
<div class="form-check form-check-inline">
    <input  class="form-check-input"  type="radio"  id="RELATIVE" formControlName="RELATIVE" value="No" >
    <label class="form-check-label" for="yes">{{'Step9-Additional-Questions.TranslationSection.text13' | translate}}</label>
</div>     


<div style="color: red;" *ngIf="isSubmitted && this.regForm.get('RELATIVE').invalid">
  ***required field***
</div>
</div>
</div>

<div class="form-row">
<div class="form-group  col-lg-5 col-sm-5 col-md-5" >
<label>5) {{'Step9-Additional-Questions.TranslationSection.text14' | translate}}
</label>

</div>
<div class="form-group  col-lg-4 col-sm-4 col-md-4" >

<div class="form-check form-check-inline">
    <input  class="form-check-input"  type="radio"  id="WORKED" formControlName="WORKED" value="Yes" >
    <label class="form-check-label" for="yes">{{'Step9-Additional-Questions.TranslationSection.text15' | translate}}</label>
</div>
<div class="form-check form-check-inline">
    <input  class="form-check-input"  type="radio"  id="WORKED" formControlName="WORKED" value="No" >
    <label class="form-check-label" for="yes">{{'Step9-Additional-Questions.TranslationSection.text16' | translate}}</label>
</div>    



<div style="color: red;" *ngIf="isSubmitted && this.regForm.get('WORKED').invalid">
  ***required field***
</div>
</div>
</div>




  
</div>

    <br/>

        <button type="button" (click) = "decreasePage()" class="btn btn-create"  matStepperPrevious><i className="ace-icon fa fa-arrow-left"></i>{{'Step9-Additional-Questions.TranslationSection.text17' | translate}}</button>
    &nbsp;
    <button type="submit"  class="btn btn-primary" >{{'Step9-Additional-Questions.TranslationSection.text18' | translate}} &nbsp;
      <i className="ace-icon fa fa-arrow-right icon-on-right"></i></button>   

      <div class="spinner-border text-success" role="status" style="position: absolute; bottom:10;" *ngIf="isfetching === true"></div>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i className="fa fa-spinner fa-spin  fa-2x" style="color:blue" *ngIf="isfetching === true"> {{'Step9-Additional-Questions.TranslationSection.text19' | translate}}</i>

    
  </form>

<!--</div>-->
  
  

  
  
  
